import {
  StoreState as FilterStoreState,
  createFilterStore,
} from 'store/filter-store';
import { namespace } from 'vuex-class';

export const locationsPositionsFilterNS = namespace(
  'shiftSchedule/locationsPositionsFilter',
);

export type StoreState = FilterStoreState;

const getStore = () => createFilterStore({ namespaced: true });

export default getStore;
